'use client';

import {
  Accordion,
  FilterCheckboxOption,
} from '@/components/molecules';
import useFilters from '@/hooks/useFilters';
import { useTranslate } from '@tolgee/react';

const filters = [
  { label: 'product_filter.sneakers', amount: 140 },
  { label: 'product_filter.boots', amount: 100 },
  { label: 'product_filter.flat_shoes', amount: 100 },
  { label: 'product_filter.high_heels', amount: 31 },
  { label: 'product_filter.sandals', amount: 1 },
];

export const ProductFilter = () => {
  const { updateFilters, isFilterActive } =
    useFilters('product');
  const { t } = useTranslate();

  const selectHandler = (option: string) => {
    updateFilters(option);
  };

  return (
    <Accordion heading={t("product_filter.heading")}>
      <ul className='px-4'>
        {filters.map(({ label, amount }) => (
          <li key={label} className='mb-4'>
            <FilterCheckboxOption
              checked={isFilterActive(label)}
              disabled={Boolean(!amount)}
              onCheck={selectHandler}
              label={t(label)}
              amount={amount}
            />
          </li>
        ))}
      </ul>
    </Accordion>
  );
};
